<div class="sg-alerts">
    <mlp-ng-alert [alert]="alert" *ngFor="let alert of alertService.alertData" 
        (removeAlert)="removeAlert(alert)" (click)="removeAlert(alert)"></mlp-ng-alert>
</div>